import { useEffect, useState } from "react";

const SLIDES = ["/hero/h1.jpg", "/hero/h2.jpg", "/hero/h3.jpg", "/hero/h4.jpg"];

export const HeroSlider = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="hero-slider" className="absolute inset-0 overflow-hidden pointer-events-none">
      {SLIDES.map((src, k) => (
        <img key={src} src={src} alt="" aria-hidden="true"
          className={`absolute inset-0 w-full h-full object-cover transition-[opacity,transform] duration-[1500ms] ease-out ${k === i ? "opacity-100 scale-105" : "opacity-0 scale-100"}`} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0F1015] via-[#0F1015]/85 to-[#0F1015]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1015] via-transparent to-[#0F1015]/60" />
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 pointer-events-auto">
        {SLIDES.map((src, k) => (
          <button key={src} data-testid={`hero-slide-dot-${k}`} aria-label={`Slide ${k + 1}`} onClick={() => setI(k)}
            className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${k === i ? "w-8 bg-red-600" : "w-3 bg-white/30 hover:bg-white/60"}`} />
        ))}
      </div>
    </div>
  );
};
